var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showing)?_c('div',[_c('div',[_c('modal-mask')],1),_c('div',{staticClass:"no-support"},[_c('div',{staticClass:"version-title"},[_vm._v("通知")]),_c('div',{staticClass:"discript"},[_vm._v("当前活动已结束/未开始")]),_c('div',{staticClass:"btn",on:{"click":_vm._close}},[_vm._v("关闭页面")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }